<template>
  <div class="nav" :class="{
    'home-page': $route.name==='Index' || $route.name==='ReleaseInformationEdit' || $route.matched[0].name==='User'
  }">
    <ul class="nav_lists">
      <li
        class="nav_list"
        :class="activeIndex == '/'?'active':''"
      ><router-link :to="{name: 'Index'}">万知首页</router-link></li>
      <li
        class="nav_list"
        v-for="(item, index) in oneType"
        :key="item.id"
        :class="activeIndex.indexOf(item.menu_en) > -1 ? 'active' : ''"
      >
        <div @click="toEachPage(item, index)">
          {{item.menu_cn}}
          <span
            v-if="
            item.menu_en !== 'education' &&
            item.menu_en !== 'love' &&
            item.menu_en !== 'talent' &&
            item.menu_en !== 'market' &&
            item.menu_en !== 'idle' &&
            item.menu_en !== 'live' &&
            item.menu_en !== 'carship' &&
            item.menu_en !== 'logistics' &&
            item.menu_en !== 'tour' &&
            item.menu_en !== 'own' &&
            item.menu_en !== 'information' &&
            item.menu_en !== 'house' &&
            item.menu_en !== 'daohang' &&
            item.menu_en !== 'same' &&
            item.menu_en !== 'wzmall'
          ">
            正在改版中
          </span>
          <!-- <span
            v-if="
            item.menu_en !== 'education' &&
            item.menu_en !== 'love' &&
            item.menu_en !== 'talent' &&
            item.menu_en !== 'market' &&
            item.menu_en !== 'idle' &&
            item.menu_en !== 'live' &&
            item.menu_en !== 'carship' &&
            item.menu_en !== 'logistics' &&
            item.menu_en !== 'tour' &&
            item.menu_en !== 'own' &&
            item.menu_en !== 'information' &&
            item.menu_en !== 'house' &&
            item.menu_en !== 'daohang' &&
            item.menu_en !== 'same'
          ">
            正在改版中
          </span> -->
        </div>
      </li>
    </ul>
    <slot name="ads"></slot>
    <div class="sn-list" v-if="showSn">
      <router-link
        v-if="hasTotal"
        :to="getTo({})"
        :class="{
          cur: isCur({})
        }"
      >全部</router-link>
      <router-link
        v-for="item of secondNavs"
        :key="item.menu_id"
        :to="getTo(item)"
        :class="{
          cur: isCur(item)
        }"
      >{{item.url||item.menu_cn}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showSn: {
      type: Boolean,
      default: false
    },
    hasTotal: {
      type: Boolean,
      default: false
    },
    curRouteName: {
      type: String
    },
    getTo: {
      type: Function
    },
    isCur: {
      type: Function
    }
  },
  data () {
    return {
      activeIndex: '/'
    }
  },
  computed: {
    navs () {
      return this.$store.getters.allType.length ? this.$store.getters.allType : []
    },
    secondNavs () {
      const curNav = this.navs.find(
        item => item.pmenu.menu_en === this.curRouteName.toLowerCase()
      )
      return curNav ? curNav.smenu : []
    },
    oneType () {
      return this.$store.getters.oneType
    }
  },
  created () {
    this.activeIndex = this.$route.path
  },
  methods: {
    hanldeBlur () {
      this.focusEd = false
      this.showMask = true
    },
    toEachPage (item, index) {
      let some = item.menu_en === 'education' ||
          item.menu_en === 'love' ||
          item.menu_en === 'talent' ||
          item.menu_en === 'market' ||
          item.menu_en === 'idle' ||
          item.menu_en === 'live' ||
          item.menu_en === 'carship' ||
          item.menu_en === 'logistics' ||
          item.menu_en === 'tour' ||
          item.menu_en === 'own' ||
          item.menu_en === 'information' ||
          item.menu_en === 'house' ||
          item.menu_en === 'daohang' ||
          item.menu_en === 'same' ||
          item.menu_en === 'wzmall'
      // let some = item.menu_en === 'education' ||
      //     item.menu_en === 'love' ||
      //     item.menu_en === 'talent' ||
      //     item.menu_en === 'market' ||
      //     item.menu_en === 'idle' ||
      //     item.menu_en === 'live' ||
      //     item.menu_en === 'carship' ||
      //     item.menu_en === 'logistics' ||
      //     item.menu_en === 'tour' ||
      //     item.menu_en === 'own' ||
      //     item.menu_en === 'information' ||
      //     item.menu_en === 'house' ||
      //     item.menu_en === 'daohang' ||
      //     item.menu_en === 'same'
      let token = localStorage.getItem('token')
      if (!token && item.menu_en === 'love') {
        this.$confirm('对不起，您还没有登录？', '提示', {
          type: 'warning',
          confirmButtonText: '去登录',
          cancelButtonText: '再看看'
        }).then(() => {
          let isFlag = 100;
          window.localStorage.setItem('isFlag',isFlag)
          this.$router.push({
            path: '/login/login',
            query: {
              flag:100,
            },
          })
        }).catch(() => {
          this.$router.push({
            path: '/'
          })
        })
      } else {
        if (some) {
          localStorage.setItem(item.menu_en + 'Type', item.id)
          localStorage.setItem(item.menu_en + 'oneTypeName', item.menu_cn)
          this.$router.push({
            name: item.menu_en.slice(0, 1).toUpperCase() + item.menu_en.slice(1), params: {id: item.id}
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.nav {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  color: #fff;
  font-size: 14px;
}
.home-page.nav{
  background-color: #ff7e00;
}
.nav_lists {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  background-color: #ff7e00;
  justify-content: space-between;
  align-items: center;
}
.nav_list {
  position: relative;
  width: 100%;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  transition: 0.5s ease;
}
.nav_list span {
  display: none;
  position: absolute;
  width: 75px;
  background: dimgrey;
  bottom: -40px;
  left: 0;
  z-index: 999;
  border-radius: 2px;
}
.nav_list:hover span {
  display: block;
}
.nav_list.active {
  background-color: #e46703;
}
.sn-list {
  /* height: 29px; */
  line-height: 29px;
  border: 1px #c5c5c5 solid;
  border-radius: 4px;
  margin: 1px auto 10px;
}
.sn-list a{
  /* margin-left: 20px; */
  width:110px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
.sn-list a:hover{
  color: #66bf7d;
}
.sn-list a.cur{
  color: #66bf7d;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Nav.vue